import React, { Component } from 'react';
import Slider from './Slider';
import Spinner from './Spinner';
import Checkbox from './Checkbox';
import ReactDOM from "react-dom";
import MediaQuery from 'react-responsive';

const sliderProperties = {
    autoplay: false,
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: false,
    arrows: true
}

class ObjectsListingItem extends Component {

    constructor(props){
        super(props);

        this.state = {
            object:this.props.object,
            details: false,
            breakfast: 0,
            dinner: 0,
            numbreakfast:1,
            numdinner:1,
            earlyCheckIn:0,
            lateCheckOut:0,
            dateInterval: this.props.dateInterval,
            numPersons: this.props.numPersons,
            doublebed:this.props.doublebed,
            kitchen:this.props.kitchen,
            placeforkids:this.props.placeforkids,
            petsallowed:this.props.petsallowed,
            promocode:this.props.promocode
        }

        this.checkEarlyCheckIn = this.checkEarlyCheckIn.bind(this);
        this.checkLateCheckOut = this.checkLateCheckOut.bind(this);
        this.checkBreakfast = this.checkBreakfast.bind(this);
        this.checkDinner = this.checkDinner.bind(this);
        this.addBrekfast = this.addBrekfast.bind(this);
        this.addDinner = this.addDinner.bind(this);
        this.changePersons = this.changePersons.bind(this);
        this.showDetails = this.showDetails.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.showRoom = this.showRoom.bind(this);
        this.showCart = this.showCart.bind(this);
        this.bookNow = this.bookNow.bind(this);
    }

    addBrekfast(v){
        if(!this.state.breakfast){
            ReactDOM.findDOMNode(this).getElementsByClassName('breakfastLabel')[0].click();
        }        
        this.setState({
            numbreakfast: v
        });
    }

    addDinner(v){
        if(!this.state.dinner){
            ReactDOM.findDOMNode(this).getElementsByClassName('dinnerLabel')[0].click();
        } 
        this.setState({
            numdinner: v
        });
    }

    checkBreakfast(event){
        if(event.target.checked){
            this.setState({
                breakfast: 1
            });
        }else{
            this.setState({
                breakfast: 0
            });
        }
    }

    checkDinner(event){
        if(event.target.checked){
            this.setState({
                dinner: 1
            });
        }else{
            this.setState({
                dinner: 0
            });
        }
    }

    checkEarlyCheckIn(event){
        if(event.target.checked){
            this.setState({
                earlyCheckIn: 1
            });
        }else{
            this.setState({
                earlyCheckIn: 0
            });
        }        
    }

    checkLateCheckOut(event){
        if(event.target.checked){
            this.setState({
                lateCheckOut: 1
            });
        }else{
            this.setState({
                lateCheckOut: 0
            });
        }
    }

    changePersons(v){
        this.setState({
            numPersons: v
        });
    }

    showDetails(){
        let status;
        this.setState({
            details: !this.state.details
        });
        if(!this.state.details){
            status = this.state.object.id
        }else{
            status = 0;
        }
        this.props.onDetailsRequest(status);
        if(this.props.onScrollTo !== undefined && status !== 0){
            const node = ReactDOM.findDOMNode(this);
            let shiftScroll = node.clientHeight;
            if(this.props.isMobile !== undefined && this.props.isMobile === true){
                shiftScroll = 0;
            }
            const top = node.offsetTop - shiftScroll;
            this.props.onScrollTo(top);
        }
    }

    addToCart(){
        if(this.props.onAddToCart !== undefined && this.props.onAddToCart !== ''){
            this.props.onAddToCart({
                object:this.props.object,
                breakfast: this.state.breakfast,
                dinner: this.state.dinner,
                numbreakfast:this.state.numbreakfast,
                numdinner:this.state.numdinner,
                earlyCheckIn:this.state.earlyCheckIn,
                lateCheckOut:this.state.lateCheckOut,
                dateInterval: this.props.dateInterval,
                numPersons: this.state.numPersons,
                doublebed:this.props.doublebed,
                promocode:this.props.promocode
            });
        }

        this.showDetails();
       
    }

    showCart(){
        this.props.onShowCart();
    }

    bookNow(){
        this.addToCart();
        this.showCart();
    }

    showRoom(){
        if(this.props.onShowRoom !== undefined && this.props.onShowRoom !== ''){
            this.props.onShowRoom(this.state);
        }
    }
    
    render(){
        let curent_price = 0;
        if(this.state.object.numbeds*1 === 1){
            if(this.state.object.bedsize === 'double' || this.state.object.bedsize === 'kingsize'){
                if(this.state.numPersons*1 === 1){
                    curent_price = this.state.object.price_1
                }else{
                    curent_price = this.state.object.price;
                }
            }else{
                curent_price = this.state.object.price;
            }
        }else if(this.state.object.numbeds*1 === 2){
            if(this.state.numPersons*1 === 1){
                curent_price = this.state.object.price_1
            }else{
                curent_price = this.state.object.price;
            }
        }else{
            if(this.state.object.numbeds*1 === this.props.numPersons*1){
                curent_price = this.state.object.price;
            }else{
                if(this.state.numPersons*1 === 1){
                    curent_price = this.state.object.price_1;                   
                }else if(this.state.numPersons*1 === 2){
                    curent_price = this.state.object.price_2;
                }else if(this.state.numPersons*1 === 3){
                    curent_price = this.state.object.price_3;
                }else{
                    curent_price = this.state.object.price;
                }           
            }            
        }
        const additionalPrice = this.state.earlyCheckIn*this.state.object.earlycheckin + 
                                this.state.lateCheckOut*this.state.object.latecheckout +
                                this.state.breakfast*this.state.numbreakfast*this.state.object.breakfastprice +
                                this.state.dinner*this.state.numdinner*this.state.object.dinnerprice;
        const numNights  = this.props.dateInterval ? Math.round(this.props.dateInterval / 86400 / 1000) : 1;
        const total = (curent_price - (this.props.promocode ? this.state.object.promodiscount : 0) + additionalPrice) * numNights;

        return(
            <div className="objectItem">
                <div className="vb-catalog-1">                                                        
                    <div className="vb-pfoto">                                
                        {this.state.object.photos.length > 0 ?
                            <Slider properties={sliderProperties} images={this.state.object.photos} slideHeight="160px" slideWidth="160px"/>
                        : ""}                               
                    </div> 
                    <div className="vb-content">
                        <h2>{this.state.object.name}</h2>
                        <div className="vb-catalog-span">
                            {this.state.object.mostpopular ? <span>Most popular room</span> : ''}&nbsp;
                            {(this.state.object.recommendedforbiz && this.props.searchReason === '1') ? <span>Reccommended For business</span> : ''}
                        </div>
                        <p>All our rates include service & taxes{this.state.object.breakfast ? ', Scandinavian breakfast' : ''}{this.state.object.wifi ? ', free WiFi' : ''}</p>
                        <div className="vb-size">Roomsize: <span>{this.state.object.roomsize} m<sup>2</sup></span></div>
                        <div className="vb-size">Bedsize: <span>{this.state.object.numbeds} {this.state.object.bedsize} bed{this.state.object.numbeds > 1 ? 's': ''}</span></div>
                    </div> 
                    <MediaQuery query="(min-width: 600px)">
                        <div className="vb-price-order">
                            <div className="vb-po-box">
                                <p className="vb-price">{curent_price * numNights}kr</p>
                                {this.state.object.oldprice !== 0 ? <p className="vb-old-price">{this.state.object.oldprice * numNights}kr</p> : ''}
                            </div>
                            <button className={this.state.details ? "vb-order vb-open" : "vb-order"} onClick={this.showDetails}>
                                Order
                            </button>
                        </div>
                    </MediaQuery>
                    <MediaQuery query="(max-width: 599px)">
                        <div className="vb-price-order">
                            <div className="vb-po-box">
                                <p className="vb-price">{curent_price * numNights}kr</p>
                               {this.state.object.oldprice !== 0 ? <p className="vb-old-price">{this.state.object.oldprice * numNights}kr</p> : ''}
                            </div>
                        </div>
                        <div className="clearfix"></div> 
                        <div className="vb-order-block">
                            <button className={this.state.details ? "vb-order vb-open" : "vb-order"} onClick={this.showDetails}>
                               Order
                            </button>
                        </div>                               
                    </MediaQuery>                            
                </div>
                {this.state.details ? 
                        <div className="vb-order-open">

                            <div className="vb-content">
                                {(this.state.object.breakfastprice || this.state.object.dinnerprice || this.state.object.earlycheckin || this.state.object.latecheckout) ? 
                                <div>
                                    <MediaQuery query="(min-width: 600px)">
                                        <h2>Room includes</h2>
                                        <div className="vb-roomincludes-box">

                                            { (this.state.object.bedsize === 'double' || this.state.object.bedsize === 'kingsize') ? 
                                            <p>
                                                <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.8249 8.01653L13.1897 5.42777V0.66561L12.5241 0H2.33055L1.66494 0.66561V5.42773L0.0297852 8.01653H14.8249ZM11.8585 1.33122V4.65402C11.0007 4.43213 9.51884 4.1585 7.42734 4.1585C5.33584 4.1585 3.85396 4.43213 2.99616 4.65402V1.33122H11.8585Z" fill="#E0E0E0"/>
                                                    <path d="M0 8.83557V10.1668H1.55099V12H2.88221V10.1668H11.9725V12H13.3038V10.1668H14.8548V8.83557H0Z" fill="#E0E0E0"/>
                                                    <path d="M6.88725 3.46588V2.69038C6.88725 2.23009 6.21921 1.85681 5.39515 1.85681C4.57108 1.85681 3.90308 2.23009 3.90308 2.69038V3.8544C3.90308 3.8544 4.7832 3.63281 5.38815 3.57553C5.93277 3.52392 6.88725 3.46588 6.88725 3.46588Z" fill="#E0E0E0"/>
                                                    <path d="M10.9517 3.8544V2.69038C10.9517 2.23009 10.2837 1.85681 9.45964 1.85681C8.63557 1.85681 7.96753 2.23009 7.96753 2.69038V3.46588C7.96753 3.46588 8.92205 3.52388 9.46667 3.57553C10.0717 3.63281 10.9517 3.8544 10.9517 3.8544Z" fill="#E0E0E0"/>
                                                </svg>		
                                                Double bed
                                            </p>
                                            : ''}
                                            
                                            {this.state.object.wifi ? 
                                            <p>
                                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.56693 5.51409C2.23778 5.84503 2.23778 6.38363 2.56693 6.71782C2.89608 7.04876 3.43175 7.04876 3.76413 6.71782C6.04236 4.42716 9.75012 4.42716 12.0284 6.71782C12.1929 6.88329 12.4091 6.96765 12.6253 6.96765C12.8415 6.96765 13.0577 6.88329 13.2223 6.71782C13.5515 6.38687 13.5515 5.84828 13.2223 5.51409C10.2858 2.55829 5.50346 2.55829 2.56693 5.51409Z" fill="#E0E0E0"/>
                                                    <path d="M4.8516 7.81124C4.52245 8.14218 4.52245 8.68078 4.8516 9.01497C5.18075 9.34591 5.71642 9.34591 6.0488 9.01497C7.06529 7.98969 8.72394 7.98969 9.74043 9.01497C9.905 9.18044 10.1212 9.2648 10.3374 9.2648C10.5536 9.2648 10.7698 9.18044 10.9344 9.01497C11.2636 8.68402 11.2636 8.14543 10.9344 7.81448C9.25961 6.12407 6.52961 6.12407 4.8516 7.81124Z" fill="#E0E0E0"/>
                                                    <path d="M7.89476 12.0001C8.51675 12.0001 9.02097 11.4931 9.02097 10.8677C9.02097 10.2423 8.51675 9.73535 7.89476 9.73535C7.27277 9.73535 6.76855 10.2423 6.76855 10.8677C6.76855 11.4931 7.27277 12.0001 7.89476 12.0001Z" fill="#E0E0E0"/>
                                                    <path d="M15.5426 3.17805C11.325 -1.05935 4.46449 -1.05935 0.246862 3.17805C-0.0822873 3.50899 -0.0822873 4.04759 0.246862 4.38178C0.576011 4.71272 1.11168 4.71272 1.44406 4.38178C5.00016 0.803028 10.7893 0.803028 14.3486 4.38178C14.5132 4.54725 14.7294 4.63161 14.9456 4.63161C15.1618 4.63161 15.378 4.54725 15.5426 4.38178C15.8718 4.05083 15.8718 3.51223 15.5426 3.17805Z" fill="#E0E0E0"/>
                                                </svg>									
                                                Wi-Fi
                                            </p>    
                                            : ''}
                                            
                                            {this.state.object.hairdryier ? 
                                            <p>
                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.4626 0.982015C11.7496 0.327348 10.3251 0 9.18922 0C8.7051 0 8.14648 0.0701439 7.51338 0.210432C6.88027 0.350719 6.35891 0.495693 5.94925 0.645324L5.36271 0.841727C5.17649 0.916893 4.99031 0.963665 4.80409 0.982015L0.279308 1.45899C0.0930932 1.49639 0 1.60862 0 1.79568V4.18058C0 4.36764 0.0930932 4.47987 0.279308 4.51727L4.80409 5.24676C4.99031 5.28416 5.17649 5.34028 5.36271 5.41511L8.43509 6.20072C8.63991 6.23815 8.77026 6.34101 8.82612 6.50935L10.6416 11.7842C10.6975 11.9712 10.8185 12.0367 11.0047 11.9806L12.9319 11.3353C13.1182 11.2605 13.174 11.1389 13.0995 10.9705L11.8426 7.29497C11.7868 7.12662 11.7589 7.03313 11.7589 7.01439C11.703 6.78993 11.6797 6.61693 11.689 6.49532C11.6987 6.37378 11.722 6.27558 11.7589 6.20072L11.7868 6.11658C11.9171 5.96695 12.0754 5.86406 12.2616 5.80794L13.4906 5.30291C13.6581 5.20939 13.7419 5.0691 13.7419 4.88204V1.37482C13.7419 1.18776 13.6488 1.05684 13.4626 0.982015ZM10.5159 3.84389C10.2646 4.08706 9.96198 4.20863 9.60818 4.20863C9.25438 4.20863 8.94715 4.08706 8.68647 3.84389C8.42579 3.60071 8.29544 3.30145 8.29544 2.94604C8.29544 2.59064 8.42579 2.28669 8.68647 2.03417C8.94715 1.78165 9.25438 1.6554 9.60818 1.6554C9.96198 1.6554 10.2646 1.78165 10.5159 2.03417C10.7673 2.28669 10.893 2.59064 10.893 2.94604C10.893 3.30148 10.7673 3.60077 10.5159 3.84389Z" fill="#E0E0E0"/>
                                                </svg>									
                                                Hair Dryer
                                            </p>
                                            : ''}
                                        </div> 
                                    </MediaQuery>
                                    <h2>Additions</h2>
                                    <div className="vb-additionals-box">
                                            {this.state.object.breakfastprice ?
                                            <div className="vb-checkbox">
                                                <Checkbox onChange={this.checkBreakfast} checked={this.state.breakfast ? true : false} id={'item_breakfast'+this.props.data_key}/>
                                                <p><label className="breakfastLabel" htmlFor={'item_breakfast'+this.props.data_key}>Breakfast included</label></p>
                                                <Spinner value="1" onChange={this.addBrekfast}/>
                                                <span className="additionPrice">Price <span>{this.state.object.breakfastprice}kr</span></span>
                                                <span className="additionTotal">Total <span className="totalItemBreakfast">{this.state.object.breakfastprice*this.state.numbreakfast*this.state.breakfast}kr</span></span>
                                            </div>
                                            : ''}
                                            {this.state.object.dinnerprice ?
                                            <div className="vb-checkbox">
                                                <Checkbox onChange={this.checkDinner} checked={this.state.dinner ? true : false} id={'item_dinner'+this.props.data_key}/>
                                                <p><label className="dinnerLabel" htmlFor={'item_dinner'+this.props.data_key}>Dinner included</label></p>
                                                <Spinner value="1" onChange={this.addDinner}/>
                                                <span className="additionPrice">Price <span>{this.state.object.dinnerprice}kr</span></span>
                                                <span className="additionTotal">Total <span className="totalItemDinner">{this.state.object.dinnerprice*this.state.numdinner*this.state.dinner}kr</span></span>
                                            </div>
                                            : ''}
                                            {this.state.object.earlycheckin ?
                                            <div className="vb-checkbox">
                                                <Checkbox value="1" onChange={this.checkEarlyCheckIn} id={'item_early_checkin'+this.props.data_key}/>
                                                <p><label htmlFor={'item_early_checkin'+this.props.data_key}>Early check-in (before 11:00 am)</label></p> 
                                                <span className="additionPrice">Price <span>{this.state.object.earlycheckin}kr</span></span>  
                                                <span className="additionTotal">Total <span className="totalItemEarlyCheckin">{this.state.object.earlycheckin*this.state.earlyCheckIn}kr</span></span>                                     
                                            </div>
                                            : ''}
                                            {this.state.object.latecheckout ?
                                            <div className="vb-checkbox">
                                                <Checkbox value="1" onChange={this.checkLateCheckOut} id={'item_late_checkout'+this.props.data_key}/>
                                                <p><label htmlFor={'item_late_checkout'+this.props.data_key}>Late check-out (after 2:00 pm) </label></p> 
                                                <span className="additionPrice">Price <span>{this.state.object.latecheckout}kr</span></span>   
                                                <span className="additionTotal">Total <span className="totalItemLateCheckout">{this.state.object.latecheckout*this.state.lateCheckOut}kr</span></span>                                     
                                            </div>
                                            : ''}
                                    </div> 
                                                                  
                                    <div className="clearfix"></div> 
                                </div>
                                : ''} 

                            </div>
                            <div className="vb-order-info">
                                <MediaQuery query="(min-width: 600px)">
                                    <div className="vb-left-border">
                                        <div className="vb-info-content-persons">
                                            <h2>Persons</h2>
                                            <div><Spinner value={this.props.numPersons ? this.props.numPersons : 1} onChange={this.changePersons}/></div>
                                        </div>
                                        <h2>Order info</h2>
                                        <div className="vb-info-box">

                                            <div className="vb-info-content">
                                                <div>Nights:</div>
                                                <div>{this.props.dateInterval ? Math.round(this.props.dateInterval / 86400 / 1000) : 1}</div>
                                            </div>                                           
                                            
                                            {additionalPrice ?
                                            <div className="vb-info-content">
                                                <div>Additionals:</div>
                                                <div>{additionalPrice}kr</div>
                                            </div>
                                            : ''}
                                            {this.props.promocode ?
                                            <div className="vb-info-content">
                                                <div>Code discount:</div>
                                                <div>{this.state.object.promodiscount}kr</div>
                                            </div>
                                            : ''}

                                            <div className="vb-info-total">
                                                <div>Total:</div>
                                                <div>{total}kr</div>
                                            </div>
                                        </div>
                                        <button className="vb-order" onClick={this.bookNow}>Book Now</button><br />
                                        <div className="vd-addtocart">
                                            or <button onClick={this.addToCart}>add to cart</button>
                                        </div>
                                    </div>
                                </MediaQuery>
                                <MediaQuery query="(max-width: 599px)">
                                    <div className="vb-top-border">
                                        <div className="vbmobile-info-content-persons">
                                            <h2>Persons</h2>
                                            <div><Spinner value={this.props.numPersons ? this.props.numPersons : 1} onChange={this.changePersons}/></div>
                                        </div>
                                        <h2>Order info</h2>
                                        <div className="order-summary">
                                            <div className="vbmobile-info-content-nights">
                                                <div className="nightsIcon"></div>
                                                <div>{this.props.dateInterval ? Math.round(this.props.dateInterval / 86400 / 1000) : 1}</div>
                                            </div>
                                            {additionalPrice ?
                                                <div className="vbmobile-info-content-additions">
                                                    <div className="additionsIcon"></div>
                                                    <div>{additionalPrice}kr</div>
                                                </div>
                                            : ''}
                                            {this.props.promocode ?
                                                <div className="vbmobile-info-content-discount">
                                                    <div className="discountIcon"></div>
                                                    <div>{this.state.object.promodiscount}kr</div>
                                                </div>
                                            : ''}
                                            <div className="vbmobile-info-total">
                                                <div className="totalLabel">Total:</div>
                                                <div>{total}kr</div>
                                            </div>
                                        </div>

                                        <button className="vbmobile-order" onClick={this.bookNow}>Book Now</button>

                                        <div className="vdmobile-addtocart">
                                            <button onClick={this.addToCart}>add to cart</button>
                                        </div>

                                    </div>
                                </MediaQuery>                                
                            </div>
                        </div>
                : ''}
            </div>
        )
    }
}

export default ObjectsListingItem;